export default __webpack_public_path__ + "static/media/pot6.73dcc7e9.svg";